"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var interfaces_1 = require("@hudled/interfaces");
var AutocompleteMaker_1 = __importDefault(require("containers/TableMaker/components/AutocompleteMaker"));
var general_1 = require("utils/general");
var constants_1 = require("../constants");
var SelectMode = (0, AutocompleteMaker_1.default)({
    collection: 'recharged_company_vendors',
    setter: function (mode, item) {
        var _a;
        return ({ plansDiscountMap: (_a = {}, _a[item.id] = { mode: mode }, _a) });
    },
    getter: function (item) { var _a; return (_a = item.planDiscount) === null || _a === void 0 ? void 0 : _a.mode; },
    idGetter: function (item) { var _a; return (_a = item.rechCompVendor) === null || _a === void 0 ? void 0 : _a.id; },
    fixedOptions: (0, general_1.makeValueLabelArray)(interfaces_1.PLAN_DISCOUNT_MODES, constants_1.PLAN_DISCOUNT_MODES_MAP),
    placeholder: 'Select discount mode',
    label: 'Select discount mode',
    noOptionsText: 'No option found',
});
exports.default = SelectMode;
